const curLocationConfig = (loc = {}, action) => {
  switch (action.type) {
    case "CUR_LOC":
      return action.playload;
    default:
      return loc;
  }
};
export default curLocationConfig;
